import PageLayout from './PageLayout';
import { GuestBook } from '@/components/wedding';

const GuestBookPage = () => (
  <PageLayout testId="guest-book-page">
    <section className="section bg-[#F8F5EF]">
      <div className="max-w-3xl mx-auto px-4">
        <GuestBook />
      </div>
    </section>
  </PageLayout>
);

export default GuestBookPage;
